import {generalRequest} from "@/lib/services/requests";
import {current_hours_and_minutes} from "@/lib/helper/date";
import {useMutation, useQuery} from "@tanstack/react-query";

export function useApiCreateStudentPaymentGenerate() {
    return useMutation({
        mutationFn: (data) =>
            (((data) => {
                return generalRequest.post(`student/payment/generate`, data)
            })(data))
    });
}


export function useApiReadStudentPaymentBalance() {
    return useQuery({
        queryKey: ['api', 'payment', 'balance', current_hours_and_minutes()],
        queryFn: () => ((() => {
            return generalRequest.get(`student/payment/balance`)
        })())
    })
}


export const useApiSearchStudentPayments = (args) => {
    return useQuery({
        queryKey: ['student', 'payment', 'list', args],
        queryFn: ({pageParam = args.page ?? 1}) => (((config) => {
            return generalRequest.get(`/student/payments`, {params: config})
        })({...args, page: pageParam})),
    })
}